import { RouteComponent } from 'react-resource-router';

import HistoryWatcher from 'src/components/performance-metrics/history-watcher';

export const UniversalRoutes = () => {
  return (
    <>
      <HistoryWatcher />
      <RouteComponent />
    </>
  );
};
